// @flow
import React from 'react';
import { Button, Icon } from '@elements';
import './TemplatesEmptyState.scss';

type Props = {
  icon: string,
  title: string,
  hint: string,
  actionText: string,
  linkTo: string,
};

// Modelos de Prescrição, de Pedido de Exames or de Documento with nothing saved yet: what a template is for,
// and the button for the first one (the list hides its toolbar's "Novo Modelo" meanwhile)
const TemplatesEmptyState = ({ icon, title, hint, actionText, linkTo }: Props) => (
  <div className="templatesEmptyState">
    <span className="templatesEmptyState-icon"><Icon iconName={icon} size={28} /></span>
    <h2>{title}</h2>
    <p>{hint}</p>
    <Button className="primary" text={actionText} linkTo={linkTo} />
  </div>
);

export default TemplatesEmptyState;
